import Http from '@/Http';
import { Categories, Hierarchy } from '@/types/work/product_category';
import { PublicCategory } from '@/types/public/products/categories';

export const CATEGORIES_REQUEST = 'pub/products/categories/request';
export const GET_CATEGORIES = 'pub/products/categories/getCategories';

const state = {
  status: '',
  categories: []
};

const getters = {
  getCategories: (state:any):Array<PublicCategory> => state.categories,
  getStructured: (state:any):Array<Hierarchy> => {
    return (new Categories([...state.categories])).getStructured();
  }
};

const actions = {
  request: ({ commit, dispatch }:any) => {
    commit('request');
    (new Http()).request({ url: `public/enterprises/product-categories` })
      .then((resp:any) => {
        commit('success', resp.data.data);
      })
      .catch(() => {
        // if resp is unauthorized, logout, to
      });
  }
};

const mutations = {
  request: (state:any) => {
    state.status = null;
  },
  success: (state:any, resp:Array<PublicCategory>) => {
    state.status = true;
    state.categories = resp;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
